(function () {
    'use strict';

    angular
        .module('EventListApp')
        .controller('VenueMapCtrl', venueMapCtrl);

    venueMapCtrl.$inject = ['SharedData'];

    function venueMapCtrl(SharedData) {
        var vm = this;
        var currentMap = -1;
        var projectCode;

        vm.mapConfig = {
            fade: true,
            alwaysOn: true,
            neverOn: false,
            // fill
            fill: false,
            fillColor: '#ffffff',
            fillOpacity: 0.1,

            // stroke
            stroke: true,
            strokeColor: '#000000',
            strokeOpacity: 0.6,
            strokeWidth: 1,

            // shadow:
            shadow: true,
            shadowColor: '#000000',
            shadowOpacity: 0.8,
            shadowRadius: 10
        }

        vm.initVM = function (selecteIndex) {
            currentMap = selecteIndex;
            vm.key = SharedData.GetKey();
            vm.event = SharedData.GetEventID();
            vm.lang = SharedData.GetLang();

            var webID = SharedData.GetWebID();
            if (typeof Ea_eventact == 'function')
                Ea_eventact(vm.event, false, '', vm.lang, webID, 6);
            /*
              todo:get venue maps from api?
              better to save in cache or local storage & get from there but no support to diffrenet domains
             */
        };

        vm.isActiveMap = function (idx) {
            return currentMap == idx;
        }

        vm.showHall = function (hall) {
            if (hall && hall.hallID)
                window.location.href = getAppUrl() + projectCode + '/vm/' + hall.hallID;
        }

        vm.setActiveMap = function (idx) {
            currentMap = idx;
        }

    }
})();
